import React from 'react'

import GbFields from './GbFields'
import GeneralFields from './GeneralFields'
import UsFields from './UsFields'

type Props = { country: string } & React.ComponentProps<typeof UsFields> &
  React.ComponentProps<typeof GbFields> &
  React.ComponentProps<typeof GeneralFields>

const CountrySpecificFields = ({
  addressLine1,
  addressLine2,
  city,
  country,
  intl,
  isPostalCodeValid,
  isSupported,
  postalCode,
  setAddressLine1,
  setAddressLine2,
  setCity,
  setPostalCode,
  setState,
  setUsState,
  state,
  usState,
  usStates
}: Props) => {
  if (country === 'US')
    return (
      <UsFields
        addressLine1={addressLine1}
        addressLine2={addressLine2}
        intl={intl}
        isSupported={isSupported}
        setAddressLine1={setAddressLine1}
        setAddressLine2={setAddressLine2}
        setUsState={setUsState}
        usState={usState}
        usStates={usStates}
        city={city}
        setCity={setCity}
        postalCode={postalCode}
        isPostalCodeValid={isPostalCodeValid}
        setPostalCode={setPostalCode}
      />
    )

  if (country === 'GB')
    return (
      <GbFields
        addressLine1={addressLine1}
        addressLine2={addressLine2}
        intl={intl}
        setAddressLine1={setAddressLine1}
        setAddressLine2={setAddressLine2}
        setState={setState}
        city={city}
        setCity={setCity}
        state={state}
        postalCode={postalCode}
        isPostalCodeValid={isPostalCodeValid}
        setPostalCode={setPostalCode}
      />
    )

  return (
    <GeneralFields
      addressLine1={addressLine1}
      addressLine2={addressLine2}
      intl={intl}
      setAddressLine1={setAddressLine1}
      setAddressLine2={setAddressLine2}
      city={city}
      setCity={setCity}
      postalCode={postalCode}
      isPostalCodeValid={isPostalCodeValid}
      setPostalCode={setPostalCode}
    />
  )
}

export default CountrySpecificFields
